export default __webpack_public_path__ + "static/media/Juliet 9781408311356.62001a02.jpg";